const  StatusOK  = 200
const  StatusLoginOK    = 201 //代表登录成功
const  StatusAcceptedUpdatePwd    = 202 //在这里表示要更改密码
const  StatusMovedPermanently = 301
const  StatusFound    = 302
const  StatusUnauthorized     = 401
const  StatusQCodeInvalid    = 403 //这里代表二位码过期
const  StatusRequestEntityTooLarge     = 413 //这里代码过期
const  StatusScanningOK   = 422 　//这里代表扫描二维码成功
const  StatusNotFound     = 404

export default  {
    StatusOK,
    StatusLoginOK,
    StatusAcceptedUpdatePwd, //在这里表示要更改密码
    StatusMovedPermanently,
    StatusFound,
    StatusUnauthorized,
    StatusQCodeInvalid,//这里代表二位码过期
    StatusRequestEntityTooLarge, //这里代码过期
    StatusScanningOK,//这里代表扫描二维码成功
    StatusNotFound,

}